/**
 * Canonical SEO/storefront vs channel override precedence.
 * Approved listing override → canonical product value → omit.
 * Snapshot must pin the resolved value; live form data is not re-read at publish.
 */
export function approvedOverrideThenCanonical(
  override?: string | null,
  canonical?: string | null,
): string | null {
  const o = typeof override === "string" ? override.trim() : "";
  if (o) return o;
  const c = typeof canonical === "string" ? canonical.trim() : "";
  return c || null;
}

export function approvedOverrideThenCanonicalBool(
  override?: boolean | null,
  canonical?: boolean | null,
  fallback = true,
): boolean {
  if (typeof override === "boolean") return override;
  if (typeof canonical === "boolean") return canonical;
  return fallback;
}

export function approvedOverrideThenCanonicalInt(
  override?: number | null,
  canonical?: number | null,
): number | null {
  if (override != null && Number.isFinite(Number(override))) return Number(override);
  if (canonical != null && Number.isFinite(Number(canonical))) return Number(canonical);
  return null;
}
